var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Payments = YouLi.Trip.Payments ? YouLi.Trip.Payments : {};

(function (YouLi) {
    (function (Trip) {
        (function (Payments) {

            YouLi.Trip.Payments.ConnectedPaymentGateway = YouLi.Common.PaymentGateway.Stripe;
            YouLi.Trip.Payments.ThirdPartyCardSurchargePercent = 0;
            YouLi.Trip.Payments.RefundProtectPercent = 0;
            YouLi.Trip.Payments.RefundProtectOptedOutConfirmed = false;
            YouLi.Trip.Payments.CurrencyHasDecimals = true;
            YouLi.Trip.Payments.SaveCardMethodType = "";

            YouLi.Trip.Payments.CostPrepayTotalForAllGangMembers = 0;

            YouLi.Trip.Payments.InviteeHasPayments = false;
            YouLi.Trip.Payments.InviteeReferenceCode = "";

            YouLi.Trip.Payments.ChipAwayMinimumAmount = 0;
            YouLi.Trip.Payments.ChipAwayMaximumAmount = 0;

            YouLi.Trip.Payments.PayNowButtonText = "Pay Now";
            YouLi.Trip.Payments.WaitlistButtonText = "Join Waitlist";

            YouLi.Trip.Payments.NotifyPlannerButtonText = "Notify Planner";
            YouLi.Trip.Payments.PackageSoldOutFooterWarningText = "Choose Another Package";
            YouLi.Trip.Payments.WaitlistMessage = "By choosing to be added to the waitlist you agree to be contacted if a spot becomes available. You can always unsubscribe if you no longer want to wait or be contacted.";

            YouLi.Trip.Payments.InviteeHasOwing = false;

            YouLi.Trip.Payments.HasAnyOwingInstallments = false;
            YouLi.Trip.Payments.SelectedInstallmentId = "";
            YouLi.Trip.Payments.InstallmentIdBalance = undefined;
            YouLi.Trip.Payments.InstallmentIdOther = undefined;

            YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay = undefined;

            YouLi.Trip.Payments.BillToEmail = undefined;
            YouLi.Trip.Payments.ApplySurchargeToAllMethods = false;

            YouLi.Trip.Payments.GetRefundProtectSelection = function () {
                if ($('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]').length > 0) {
                    return $('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]:checked').val();
                }
                else {
                    return $('input[name="CurrentInvitee.RefundProtectSelection"]').val();
                }
            }

            YouLi.Trip.Payments.CheckForPaymentButtonUpdate = function () {

                // If we have a selected payment method, update the footer to have the payment button (in case it's not already set)
                if ($("input[type=radio][name=PaymentMethod]:checked").val()) {
                    SetFooterToPaymentButton($("input[type=radio][name=PaymentMethod]:checked").val());
                }
            };

            YouLi.Trip.Payments.InitialiseResponseChecks = function () {
                $(".content-trip-paymentdetails-itinerary-addons .multistate-check-schedule-item-response").multiStateCheck({
                    states: ["unchecked", "checked"],
                    onAfterChangeState: function (e) {

                        const $current = $(e.target);
                        const itemId = $current.data("id");
                        const $allCheckboxes = $(`.content-trip-paymentdetails-itinerary-addons .multistate-check-schedule-item-response[data-id="${itemId}"]`);
                        const $first = $allCheckboxes.first();

                        if (!$current.is($first)
                            && $current.attr("data-state") === "checked"
                            && $first.attr("data-state") !== "checked"
                            && $first.data("is-responding-for-gang")) {
                            $current.attr("data-state", "unchecked");
                            return;
                        }

                        YouLi.Common.UI.ShowLoading();

                        const applyToGang = $(e.target).data("is-responding-for-gang");
                        YouLi.Trip.Schedule.Response.MultiStateCheckUpdateAndTakeAction(e.target, applyToGang, function () {
                            YouLi.Common.UI.HideLoading();
                        }, true);
                    }
                }).each(function () {
                    if ($("#PreviewMode").val() == "True") {
                        $(this).attr("disabled", "");
                    }
                });
            };


            /* Returns a promise */
            YouLi.Trip.Payments.CheckForOverpayment = function () {

                let data = {
                    couponCode: $("#ChargeCouponCode").val(),
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    chargeAmount: $("#ChargeAmount").val(),
                    surchargeAmount: $("#SurchargeAmount").val(),
                    refundProtectAmount: $("#RefundProtectAmount").val()
                };

                return new Promise((resolve) => {
                    YouLi.Common.Post({
                        url: '/trip/checkpaymentforoverpayment',
                        params: data,
                        errorCallback: function () {
                            const errorDate = moment();

                            $(".content-trip-paymentdetails-error").removeClass("hidden");
                            $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));
                            $("#PaymentErrorMessage").text("");
                        }
                    }).then((response) => {
                        let errorDate;
                        if (response.url) {
                            window.open(response.url, '_blank');
                        }
                        else if (response.errorMessage) {
                            $(".content-trip-paymentdetails-error").removeClass("hidden");

                            errorDate = moment(response.paymentErrorDate);

                            $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));
                            $("#PaymentErrorMessage").text(response.errorMessage);
                        }
                        else if (response.cookieError && response.message) {
                            YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.message, "Identity error");
                        }
                        else {
                            resolve();
                        }
                    });
                });

            };

            YouLi.Trip.Payments.processPaymentWithSavedPaymentMethod = function (isThirdPartyCard) {

                let newPaymentId, couponPaymentId;
                var redirectURL = window.location.href;

                if (YouLi.Trip.Payments.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Stripe) {
                    const savedPaymentMethodId = isThirdPartyCard ? $("#ThirdPartyCardPaymentMethodId").val() : $("#SavedPaymentMethodId").val();

                    YouLi.Trip.Payments.CheckForOverpayment()
                        .then(() => {
                            YouLi.Common.UI.ShowLoading();
                        })
                        .then(() => YouLi.Trip.Payments.ProcessStripePayment(undefined, "stripe", savedPaymentMethodId))
                        .then((data) => {

                            newPaymentId = data.newPaymentId;
                            couponPaymentId = data.couponPaymentId;

                            if (data.redirectURL) {
                                redirectURL = data.redirectURL;
                            }

                            // 3. Create and Confirm Payment Intent to charge immediately

                            // First, ensure it's actually got a paymentId
                            if (!newPaymentId) {
                                var userMessage = "An error occurred with the payment charge - invalid payment Id";
                                var debugMessage = "Credit Card failure: passed a " + (newPaymentId == null ? "null" : "empty string") + " for paymentId on trip "
                                    + $("#TripId").val() + " for invitee " + $("#InviteeId").val() + " is failing. Domain: " + window.location.host
                                var subject = "Exception occurring - internalPaymentId is being set to an invalid value in Stripe Payment Intent";

                                YouLi.Common.OpenSupportTicket(userMessage, debugMessage, subject);

                                throw new Error(userMessage);
                            }

                            const isEnrolInAutoPayChecked = !isThirdPartyCard && $("#SavedPaymentMethodConfirmationDialog #EnrolInAutoPay").is(":checked");

                            return YouLi.Trip.Payments.ChargeStripeSavedPaymentMethod(newPaymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId, isEnrolInAutoPayChecked);
                        })
                        .then((data) => {

                            if (data.redirectURL) {
                                redirectURL = data.redirectURL; // update from the payment intent
                            }

                            if (window.location.href == redirectURL)
                                window.location.reload();
                            else
                                window.location.href = redirectURL;

                        })
                        .catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                            var paymentsToDelete = [];
                            if (newPaymentId)
                                paymentsToDelete.push(newPaymentId);
                            if (couponPaymentId)
                                paymentsToDelete.push(couponPaymentId);
                            YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                            YouLi.Common.UI.HideLoading();

                            if (!errorObject.errorHandled) {
                                YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                            }

                        });
                }
                else if (YouLi.Trip.Payments.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.PayPal) {

                    const savedPaymentMethodId = $("#SavedPaymentMethodId").val();      // Nb: no handling third party cards for now

                    YouLi.Trip.Payments.CheckForOverpayment()
                        .then(() => {
                            YouLi.Common.UI.ShowLoading();
                        })
                        .then(() => processPayment("paypal", savedPaymentMethodId))
                        .then((response) => {
                            YouLi.Common.UI.HideLoading();
                        })
                        .catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                            var paymentsToDelete = [];
                            if (newPaymentId)
                                paymentsToDelete.push(newPaymentId);
                            if (couponPaymentId)
                                paymentsToDelete.push(couponPaymentId);
                            YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                            YouLi.Common.UI.HideLoading();

                            if (!errorObject.errorHandled) {
                                YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                            }

                        });
                }
                else {
                    console.log("Invalid gateway for saved payment method");
                }

            }

            YouLi.Trip.Payments.ChargeStripeSavedPaymentMethod = function (paymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId, isEnrolInAutoPayChecked) {

                let data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    inviteeReferenceCode: YouLi.Trip.Payments.InviteeReferenceCode,
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val(),
                    paymentId: paymentId,
                    isRegisteredWithPayment: false, // never true for Trip Page, only for Checkout
                    useThirdPartyCardPaymentMethod: isThirdPartyCard,
                    thirdPartyCardPaymentCostCentre: $("#ThirdPartyCardPaymentCostCentre").val(),
                    thirdPartyCardPaymentDepartment: $("#ThirdPartyCardPaymentDepartment").val(),
                    thirdPartyCardPaymentApprovedBy: $("#ThirdPartyCardPaymentApprovedBy").val(),
                    savedPaymentMethodId: savedPaymentMethodId,
                    isAutoPayEnrol: isEnrolInAutoPayChecked,
                    returnURL: redirectURL,
                };

                return new Promise((resolve, reject) => {
                    YouLi.Common.Post({
                        url: '/trip/chargestripesavedpaymentmethod',
                        params: data,
                        suppressLoading: true,
                        errorCallback: function () {
                            YouLi.Trip.Payments.ShowErrorOnPage("Error processing payment.  Please try again or contact your planner for assistance", moment());

                            reject({
                                message: "Error charging payment",
                                errorHandled: true
                            });
                        }
                    }).then((response) => {
                        if (!response.success) {
                            YouLi.Trip.Payments.ShowErrorOnPage("Error processing payment.  Please try again or contact your planner for assistance", moment());

                            reject({
                                message: "Error charging payment",
                                errorHandled: true
                            });
                            return;
                        }

                        resolve({ redirectURL: response.redirectURL });
                    });
                });
            }

            YouLi.Trip.Payments.RefreshPaymentMethod = function (preventScroll = false) {
                ChangeMethod($("input[type=radio][name=PaymentMethod]:checked").val(), preventScroll);
                ClearFooterPaymentButton();
                ForceFooterUpdate();
            }

            YouLi.Trip.Payments.UpdateGangPlaceholdersFormSuccess = function (result) {

                var formSubmitBtn = $("form").find("input[type='submit']");

                if (result.errors) {
                    YouLi.Common.UI.HideInputLoading(formSubmitBtn);
                    YouLi.Common.UI.HideLoading();
                    YouLi.Common.UI.ClearClientSideErrors();
                    YouLi.Common.UI.FormatClientSideErrors(result.errors);

                } else {
                    YouLi.Common.UI.ClearClientSideErrors();

                    // Update the payment details UI now their name etc has changed
                    if (result.showCosts) {
                        $(".content-tab-paymentdetails").removeClass("hidden");
                    }

                    RefreshInviteesTab(result.inviteesDetailsHtmlString, result.showInvitees);

                    var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                    if ($(".content-trip-paymentdetails-costs").length > 0)
                        $(".content-trip-paymentdetails-costs").html(result.paymentDetailsHtml);

                    YouLi.Trip.Payments.InitialiseUI();
                    YouLi.Common.UI.Init();

                    // reinitialise
                    $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                    ChangeMethod(initialSelectedPaymentMethod, true);

                    $('#GangPlaceholdersDialog').modal('hide');
                }
            };

            YouLi.Trip.Payments.UpdateGangPlaceholdersFormFailure = function (xhr, status, error) {
                var formSubmitBtn = $("form").find("input[type='submit']");
                YouLi.Common.UI.HideInputLoading(formSubmitBtn);

                YouLi.Common.UI.FormatClientSideErrors(error, xhr);

                $('#GangPlaceholdersDialog').animate({ scrollTop: 0 }, 800);
            };

            var hasBillingAddress = function () {
                return $("#BillToFieldsIncluded") && $("#BillToFieldsIncluded").val() == "true";
            }

            /* Returns a promise */
            var processPayment = function (paymentMethod, savedPaymentMethodId) {

                var dataString = new FormData($("#PaymentChargeForm")[0]);

                $(".content-trip-paymentdetails-error").addClass("hidden");
                $(".paypal-trip-paymentdetails-error").addClass("hidden");

                dataString.append("paymentMethod", paymentMethod);

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                dataString.append("isChipAway", isChipAwaySelected);

                dataString.append("isRegisteredWithPayment", false);// never true for Trip Page, only for Checkout

                if (YouLi.Trip.Payments.RefundProtectOptedOutConfirmed)
                    dataString.append("optedOutRefundProtect", true);

                dataString.append("RefundProtectSelection", YouLi.Trip.Payments.GetRefundProtectSelection());

                dataString.append("includedBillingAddress", hasBillingAddress());
                if (hasBillingAddress()) {
                    // add credit card form details like billing details
                    var creditCardFormData = new FormData($('#GenericPaymentForm')[0]);
                    for (let pair of creditCardFormData.entries()) {
                        dataString.append(pair[0], pair[1]);
                    }
                }

                if ($('input[type=radio][name=PaymentMethod]:checked').val() === "thirdpartycard") {
                    data["IsThirdPartyCardPayment"] = true;
                    data["ThirdPartyCardPaymentCostCentre"] = $("#ThirdPartyCardPaymentCostCentre").val();
                    data["ThirdPartyCardPaymentDepartment"] = $("#ThirdPartyCardPaymentDepartment").val();
                    data["ThirdPartyCardPaymentApprovedBy"] = $("#ThirdPartyCardPaymentApprovedBy").val();
                }

                if (savedPaymentMethodId) {
                    dataString.append("SavedPaymentMethodId", savedPaymentMethodId);
                }

                return new Promise(function (resolve) {
                    var completePaymentRequest = function (response) {

                        if ($("#GenericPaymentFormDialog").hasClass("in")) {
                            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                            $("#GenericPaymentFormDialog").modal("hide");
                        }

                        if (response == null) {
                            YouLi.Trip.Payments.ShowErrorOnPage('', moment());
                            YouLi.Trip.Payments.RefreshPaymentMethod(true);
                            resolve(response);
                            return;
                        }

                        if (response.statusCode === 500) {
                            YouLi.Trip.Payments.ShowErrorOnPage(response.paymentErrorMessage, moment(response.paymentErrorDate), paymentMethod);
                            YouLi.Trip.Payments.RefreshPaymentMethod(true);
                        }
                        else if (response.cookieError && response.message) {
                            YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.message, 'Identity error');
                        }
                        else {

                            if ($("#IsBooked").val() != "True") {
                                if (YouLi.Common.GetGAData != null) {
                                    var gaData = YouLi.Common.GetGAData("purchase");
                                    dataLayer.push({ ecommerce: null });
                                    dataLayer.push(gaData);
                                }
                            }

                            $('#payment-detail-content').html(response.paymentDetailsHtmlString);
                            $("#content-trip-paymentdetails").removeClass("hidden");
                            YouLi.Trip.Payments.InitialiseUI();
                            YouLi.Common.UI.Init();
                            $('.trip-heading-title').html(response.tripHeadingTitle);
                            $('.content-trip-heading-details.content-trip-heading-details-bullets').html(response.tripHeadingDetails);
                            RefreshInviteesTab(response.inviteesDetailsHtmlString, response.showInvitees);
                            $('#tasks-content').html(response.tasksListHtmlString);
                            YouLi.Trip.ShowInviteesAllTab = response.showInviteesAllTab;

                            $('html, body').animate({
                                scrollTop: $(".cost-payments").offset().top - 80
                            }, 1000, () => {
                                if (response.placeholdersDetails) {
                                    $('#GangPlaceholdersDialogContent').html(response.placeholdersDetails);
                                    $('#GangPlaceholdersDialog').modal('show');
                                }
                            });

                            dataLayer.push({
                                'tripName': $("#TripName").val(),
                                'totalPrice': YouLi.Trip.Payments.CostPrepayTotalForAllGangMembers,
                                'paymentAmount': YouLi.PaymentChargeForm.GetChargeAmount(),
                                'event': 'Trip Booked'
                            });

                            $('#GoogleAnalyticsData').html(response.googleAnalyticsHtml);

                            YouLi.Trip.SetupUpdatePaymentsListTimer();

                            YouLi.Trip.Payments.RefreshPaymentMethod();

                            if (response.redirectURL && (paymentMethod != "phone" || YouLi.Common.Utils.IsMobile())) {
                                window.location.href = response.redirectURL;
                            }
                        }

                        resolve(response);
                    };

                    YouLi.Common.Post({
                        url: '/trip/inviteemakepayment',
                        params: dataString,
                        contentType: false,
                        errorCallback: function (error) {
                            if (error.responseJSON) {
                                completePaymentRequest(error.responseJSON);
                                return;
                            }

                            completePaymentRequest(null);
                        }
                    }).then(function (response) {
                        completePaymentRequest(response);
                    });
                });
            };

            YouLi.Trip.Payments.ShowErrorOnPage = function (errorMessage, errorDate /* a Moment date */, paymentMethod) {

                if (errorDate)
                    $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));

                $(".payment-error-message").text(errorMessage);

                if ($("#GenericPaymentFormDialog").hasClass("in")) {
                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                    $("#GenericPaymentFormDialog").modal("hide");
                }

                if (paymentMethod === 'paypal') {
                    $('.paypal-trip-paymentdetails-error').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('.paypal-trip-paymentdetails-error').offset().top - 80
                    }, 1000);

                } else {
                    $('.content-trip-paymentdetails-error').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('.content-trip-paymentdetails-error').offset().top - 80
                    }, 1000);

                }
            };

            YouLi.Trip.Payments.ProcessGenericCreditCardPayment = function (nonce, paymentMethod) {

                if (nonce) {
                    var $form = $('#PaymentChargeForm');

                    $("#chargeNonce").remove();
                    $form.append($('<input type="hidden" id="chargeNonce" name="chargeNonce">').val(nonce));
                }

                return processPayment(paymentMethod); // TODO: Base this on the planner's settings
            };

            /* Returns a promise */
            YouLi.Trip.Payments.ProcessStripePayment = function (paymentIntentId, paymentMethod, savedPaymentMethodId) {

                var dataString = new FormData($("#PaymentChargeForm")[0]);

                dataString.append("paymentMethod", "stripe");

                const pmType = YouLi.CreditCardPaymentForm.SelectedPaymentMethodType;
                if (pmType) {
                    dataString.append("paymentMethodType", pmType);
                }

                const stripeIntegrationType = YouLi.CreditCardPaymentForm.StripeIntegrationType;
                if (stripeIntegrationType) {
                    dataString.append('stripeIntegrationType', stripeIntegrationType);
                }

                if (savedPaymentMethodId) {
                    dataString.append("savedPaymentMethodId", savedPaymentMethodId);
                }

                // Enrol in AutoPay can be done either using Saved PM dialog or Card Dialog
                // If checkbox is checked in one of the dialog, treat as intention to enrol
                const isInSavedDialog = $("#SavedPaymentMethodConfirmationDialog #EnrolInAutoPay").is(":checked");
                const isInGenericDialog = $("#GenericPaymentFormDialog #EnrolInAutoPay").is(":checked");
                const isIntentionToEnrolInAutoPay = isInSavedDialog || isInGenericDialog;
                if (isIntentionToEnrolInAutoPay) {
                    dataString.append("IsIntentionToEnrolInAutoPay", true);
                }

                if (paymentIntentId) {
                    var $form = $('#PaymentChargeForm');

                    $("#chargeNonce").remove();
                    $form.append($('<input type="hidden" id="chargeNonce" name="chargeNonce">').val(paymentIntentId));
                }

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                dataString.append("isChipAway", isChipAwaySelected);

                dataString.append("isRegisteredWithPayment", false);// never true for Trip Page, only for Checkout

                if (YouLi.Trip.Payments.RefundProtectOptedOutConfirmed)
                    dataString.append("optedOutRefundProtect", true);

                dataString.append("RefundProtectSelection", YouLi.Trip.Payments.GetRefundProtectSelection());

                dataString.append("includedBillingAddress", hasBillingAddress());
                if (hasBillingAddress()) {
                    // add credit card form details like billing details
                    let isBillingCountryDisabled = false;
                    let isBillingStateDisabled = false;

                    if ($('#p-billto-country').is(':disabled')) {
                        isBillingCountryDisabled = true;
                        $('#p-billto-country').prop('disabled', false);
                    }

                    if ($('#p-billto-state').is(':disabled')) {
                        isBillingStateDisabled = true;
                        $('#p-billto-state').prop('disabled', false);
                    }

                    const creditCardFormData = new FormData($('#GenericPaymentForm')[0]);
                    for (let pair of creditCardFormData.entries()) {
                        dataString.append(pair[0], pair[1]);
                    }

                    if (isBillingCountryDisabled) {
                        $('#p-billto-country').prop('disabled', true);
                    }

                    if(isBillingStateDisabled) {
                        $('#p-billto-state').prop('disabled', true);
                    }
                }

                if ($('input[type=radio][name=PaymentMethod]:checked').val() === "thirdpartycard") {
                    dataString.append("IsThirdPartyCardPayment", true);
                    dataString.append("ThirdPartyCardPaymentCostCentre", $("#ThirdPartyCardPaymentCostCentre").val());
                    dataString.append("ThirdPartyCardPaymentDepartment", $("#ThirdPartyCardPaymentDepartment").val());
                    dataString.append("ThirdPartyCardPaymentApprovedBy", $("#ThirdPartyCardPaymentApprovedBy").val());
                }

                return new Promise(function (resolve, reject) {
                    YouLi.Common.Post({
                        url: '/trip/inviteemakepayment',
                        params: dataString,
                        contentType: false,
                        suppressLoading: true,
                        errorCallback: function (error) {
                            if (error && error.statusCode == 500) {
                                YouLi.Trip.Payments.ShowErrorOnPage(error.paymentErrorMessage, moment(error.paymentErrorDate));
                                YouLi.Trip.Payments.RefreshPaymentMethod(true);
                                reject({
                                    message: 'Failed to create payment: ' + error.paymentErrorMessage,
                                    errorHandled: true
                                });
                                return;
                            }

                            reject({
                                message: 'Failed to create payment',
                                errorHandled: false
                            });
                        }
                    }).then(function (data) {
                        if (data.statusCode == 500) {

                            YouLi.Trip.Payments.ShowErrorOnPage(data.paymentErrorMessage, moment(data.paymentErrorDate));

                            YouLi.Trip.Payments.RefreshPaymentMethod(true);

                            reject({
                                message: 'Failed to create payment: ' + data.paymentErrorMessage,
                                errorHandled: true
                            });
                            return;
                        }
                        else if (data.cookieError && data.message) {
                            $("#GenericPaymentFormDialog").modal("hide");

                            YouLi.Common.UI.ShowStaticStandardDialogNoClose(data.message, 'Identity error');

                            reject({
                                message: data.message,
                                errorHandled: true
                            });
                            return;
                        }

                        if ($("#IsBooked").val() != "True") {
                            if (YouLi.Common.GetGAData != null) {
                                var gaData = YouLi.Common.GetGAData("purchase");
                                dataLayer.push({ ecommerce: null });
                                dataLayer.push(gaData);
                            }
                        }
                        $('#GoogleAnalyticsData').html(data.googleAnalyticsHtml);

                        resolve({
                            newPaymentId: data.newPaymentId,
                            couponPaymentId: data.couponPaymentId,
                            redirectURL: data.redirectURL
                        });
                    });
                });
            };

            var ForceFooterUpdate = function () {
                YouLi.Trip.FooterUpdatesPaused = false;
                YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
            };

            var SetFooterToPaymentButton = function (selectedMethod) {

                // update footer for payment button
                if (selectedMethod) {
                    YouLi.Trip.FooterUpdatesPaused = true;
                    var footerForPayment = "";
                    let isPackageSoldout = $(".pay-now-button-label").data('sold-out');
                    let isFull = $(".pay-now-button-label").data('already-full');
                    let wouldOverbook = $(".pay-now-button-label").data('would-overbook');
                    let isWaitlist = $(".pay-now-button-label").data('waitlist');

                    if (isFull) {

                        if (isWaitlist)
                            footerForPayment = `<p class='footer-payment-label'>${YouLi.Trip.Payments.WaitlistMessage}</p>`;
                        else
                            footerForPayment = `<p class='footer-payment-label'>Sorry, this trip is now SOLD OUT.</p>`;
                    } else if (wouldOverbook) {
                        if (isWaitlist)
                            footerForPayment = `<p class='footer-payment-label'>${YouLi.Trip.Payments.WaitlistMessage}</p>`;
                        else
                            footerForPayment = `<p class='footer-payment-label'>Sorry, too many people, select a lower occupancy or another package.</p>`;
                    }
                    else if (isPackageSoldout) {
                        if (isWaitlist)
                            footerForPayment = `<p class='footer-payment-label'>${YouLi.Trip.Payments.WaitlistMessage}</p>`;
                        else
                            footerForPayment = `<p class='footer-payment-label'>${YouLi.Trip.Payments.PackageSoldOutFooterWarningText}</p>`;
                    } else {
                        footerForPayment = $("<p class='footer-payment-label'>Amount to be paid next </p>")
                            .append(`<span class='cost-line-item-amount-payment-total'>${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount())}</span>`);
                    }
                    $(".content-trip-response-footer")
                        .removeClass("hidden")
                        .html(footerForPayment);

                    $(".content-trip-response-footer").append($(".payment-button").clone());
                }
            };

            var ClearFooterPaymentButton = function () {
                $(".content-trip-response-footer").html("");
            }

            var ChangePaymentOption = function (selectedOption) {

                $(".installments-details").addClass("hidden");

                if (!YouLi.Trip.Payments.InviteeHasPayments && selectedOption == "installment") {
                    $(".installments-details").removeClass("hidden");
                }

                YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");

                $(".cost-line-item-payment-total").toggleClass("hidden", !selectedOption); // only show if a method is selected

                $("#ChipAwayPaymentOptionDetails").toggleClass("hidden", selectedOption != "chipaway");

                // Reset teh selected installment value
                if (selectedOption == "installment")
                    YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdOther;
                else if (selectedOption == "chipaway") {
                    // "chip away" at the next installment or the balance if there's no installments owed
                    if (YouLi.Trip.Payments.HasAnyOwingInstallments)
                        YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdOther;
                    else
                        YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdBalance;
                }
                else
                    YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdBalance;

                TogglePaymentButtonVisiblity();

                ToggleAutoPayOptionVisibility();

                // now update the actual payment amount
                GetSelectedPaymentOptionAmount();
            }

            var GetSelectedPaymentOptionAmount = function () {

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                const chipAwayPaymentAmount = $("#CurrentInvitee_ChipAwayPaymentAmount").val();

                if (isChipAwaySelected) {
                    if (chipAwayPaymentAmount == "" || chipAwayPaymentAmount < YouLi.Trip.Payments.ChipAwayMinimumAmount) {

                        $("#ChipAwayErrorMessage").text(`Payment cannot be less than ${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.Trip.Payments.ChipAwayMinimumAmount)}`).removeClass("hidden");
                        return;
                    }
                    else if (chipAwayPaymentAmount > YouLi.Trip.Payments.ChipAwayMaximumAmount) {

                        $("#ChipAwayErrorMessage").text(`Payment cannot be greater than the amount you owe, ${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.Trip.Payments.ChipAwayMaximumAmount)}`).removeClass("hidden");
                        return;
                    }
                }

                var previewMode = $("#PreviewMode").val();
                let data = {
                    preview: previewMode,
                    costInstallmentId: isChipAwaySelected ? '' : YouLi.Trip.Payments.SelectedInstallmentId,
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    couponCode: $("#ChargeCouponCode").val(),
                    isChipAway: isChipAwaySelected,
                    chipAwayPaymentAmount: chipAwayPaymentAmount,
                    chargeReservationNumber: $("#ChargeReservationNumber").val(),
                }

                if (previewMode.toLowerCase() == "true") {
                    data.selectedTripPackageId = $("#SelectedPackageId").val();
                }

                YouLi.Common.Post({
                    url: '/trip/getinstallmentamount',
                    params: data,
                    errorCallback: function () {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                    }
                }).then((response) => {
                    if (response.url) {
                        window.location.href = response.url;
                    }
                    else if (response.success === false) {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                    }
                    else if (response.cookieError && response.message) {
                        YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.message, "Identity error");
                    }
                    else {
                        YouLi.PaymentChargeForm.AmountDue = response.installmentAmountDue; // + response.upfrontPaymentAmount;

                        if (!isChipAwaySelected) {
                            if (response.installmentIsBalance)
                                $(".amount-due-balance").html(YouLi.Common.Currency.DisplayCost(YouLi.PaymentChargeForm.Currency, YouLi.PaymentChargeForm.AmountDue));
                            else
                                $(".amount-due-installment").html(YouLi.Common.Currency.DisplayCost(YouLi.PaymentChargeForm.Currency, YouLi.PaymentChargeForm.AmountDue));
                        }

                        UpdateChargeDetails(response.chargeLabel);

                        $("input[Name=ChargeInstallmentId]").val(YouLi.Trip.Payments.SelectedInstallmentId);
                    }
                });
            };

            var ChangeMethod = function (selectedMethod, preventScroll, scrollToPaymentLine) {

                var selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');

                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                // If the user initiated this change, scroll to the top of the Payment Methods selection if it is being shown, otherwise scroll to the top of the payments table (YOULI-3747)
                if (selectedPaymentOption && !preventScroll) {
                    var scrollTarget = $("#ChoosePaymentMethodTitle").length > 0 && scrollToPaymentLine ? $("#ChoosePaymentMethodTitle") : $(".content-trip-package-container");
                    $('html, body').animate({
                        scrollTop: scrollTarget.offset().top - 80
                    }, 1000);
                }

                // hide all and then show whichever is needed
                $(".payment-surcharge-val").addClass("hidden");
                $(".refund-protect-val").addClass("hidden");
                $("#RefundProtectSelection").addClass("hidden");
                $(".payment-method-details").addClass("hidden");

                $("#PhoneDetails").addClass("hidden");
                $("#SavedPaymentMethodAutoPayDetails").addClass("hidden");
                $("#ThirdPartyCardDetails").addClass("hidden");
                $("#BankTransferDetails").addClass("hidden");




                // standard labels
                let isPackageSoldout = $(".pay-now-button-label").data('sold-out');
                let isFull = $(".pay-now-button-label").data('already-full');
                let wouldOverbook = $(".pay-now-button-label").data('would-overbook');
                let isWaitlist = $(".pay-now-button-label").data('waitlist');

                $(".pay-now-button-label").text(
                    getPaymentButtonLabel(YouLi.Trip.Payments.PayNowButtonText, isFull, wouldOverbook, isPackageSoldout, isWaitlist)
                );

                // if the tab is currently being displayed, update the footer for the selected method
                var tabIsSelected = !$("#content-trip-paymentdetails").hasClass("hidden");
                if (tabIsSelected && selectedMethod)
                    SetFooterToPaymentButton(selectedMethod);

                switch (selectedMethod) {
                    case "savedpaymentmethod":
                        if (selectedPaymentOption && YouLi.Trip.HasAchSurcharge === false) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0) {
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                            }
                        }

                        // on saved payment, we usually add surcharge method select, we won't do that for saved card for now.
                        if (YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled) {
                            YouLi.PaymentChargeForm.Default.SurchargePercent = 0;
                        }

                        break;
                    case "thirdpartycard":
                        if (selectedPaymentOption) {
                            if (YouLi.Trip.Payments.ThirdPartyCardSurchargePercent > 0) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                            }
                        }
                        $("#ThirdPartyCardDetails").removeClass("hidden");
                        break;
                    case "banktransfer":
                        $("#PayBankTransfer").removeClass("hidden");
                        $("#BankTransferDetails").removeClass("hidden");
                        // override some labels
                        $(".pay-now-button-label").text(
                            getPaymentButtonLabel(YouLi.Trip.Payments.NotifyPlannerButtonText, isFull, wouldOverbook, isPackageSoldout, isWaitlist)
                        );
                        break;
                    case "paymentgateway":
                        $("#PayPaymentGateway").removeClass("hidden");

                        if (selectedPaymentOption && YouLi.Trip.HasAchSurcharge === false) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0) {
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "paypallink":
                        $("#PayPayPalLink").removeClass("hidden");
                        break;
                    case "phone":
                        $("#PayPhone").removeClass("hidden");
                        $("#PhoneDetails").removeClass("hidden");
                        var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
                        var defaultLabel = isMobile ? YouLi.Trip.Payments.PayNowButtonText : YouLi.Trip.Payments.NotifyPlannerButtonText;
                        $(".pay-now-button-label").text(
                            getPaymentButtonLabel(defaultLabel, isFull, wouldOverbook, isPackageSoldout, isWaitlist)
                        );
                        break;
                    case "customlink":
                        $("#PayCustomLink").removeClass("hidden");
                        break;
                }

                ToggleRefundProtectVisiblity();

                TogglePaymentButtonVisiblity();

                ToggleAutoPayOptionVisibility();

                // update the charge details if they have selected a method - we have to redo this here because of method-based surcharges
                if (selectedMethod)
                    UpdateChargeDetails(undefined);
            };

            var getPaymentButtonLabel = function (defaultLabel, isFull, wouldOverbook, isPackageSoldout, isWaitlist) {
                if (isFull)
                    return isWaitlist ? YouLi.Trip.Payments.WaitlistButtonText : 'Sold Out';

                if (wouldOverbook)
                    return isWaitlist ? YouLi.Trip.Payments.WaitlistButtonText : 'Update Occupancy or Package';

                if (isPackageSoldout)
                    return isWaitlist ? YouLi.Trip.Payments.WaitlistButtonText : 'Sold Out';

                return defaultLabel;
            };

            var ToggleRefundProtectVisiblity = function () {
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                if (selectedPaymentMethod) {
                    if (selectedPaymentOption) {
                        $(".refund-protect-val").removeClass("hidden");
                    }

                    if (YouLi.Trip.Payments.RefundProtectPercent > 0) {
                        $("#RefundProtectSelection").removeClass("hidden");
                    }
                }

            }

            var TogglePaymentButtonVisiblity = function () {
                const selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                const selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                const chipAwayPaymentAmount = $("#CurrentInvitee_ChipAwayPaymentAmount").val();
                const validChipAwayAmountEntered = !isChipAwaySelected || (chipAwayPaymentAmount >= YouLi.Trip.Payments.ChipAwayMinimumAmount && chipAwayPaymentAmount <= YouLi.Trip.Payments.ChipAwayMaximumAmount);

                // Only show if a method AND the payment option have both been selected, and chip away amount is valid if that is the selected payment optoin
                const showPaymentButtons = !(selectedPaymentMethod && selectedPaymentOption && validChipAwayAmountEntered);
                $(".payment-button").toggleClass("hidden", showPaymentButtons);

                $(".enrol-in-autopay").toggleClass("hidden", showPaymentButtons);
            };

            var ToggleAutoPayOptionVisibility = function () {
                const selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                const selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                const showSavedPaymentMethodAutoPayDetails = selectedPaymentMethod == "savedpaymentmethod"
                    && selectedPaymentOption
                    && (YouLi.Trip.Payments.HasAnyOwingInstallments && YouLi.Trip.Payments.SelectedInstallmentId !== YouLi.Trip.Payments.InstallmentIdBalance);
                $("#SavedPaymentMethodAutoPayDetails").toggleClass("hidden", !showSavedPaymentMethodAutoPayDetails);

                // show the "promo" for AutoPay under credit card when no installment has been seleted at all, or when the balance has not been selected
                const showCreditCardAutoPayDetails = !selectedPaymentOption
                    || (YouLi.Trip.Payments.HasAnyOwingInstallments && YouLi.Trip.Payments.SelectedInstallmentId !== YouLi.Trip.Payments.InstallmentIdBalance);
                $("#CreditCardAutoPayDetails").toggleClass("hidden", !showCreditCardAutoPayDetails);
            };

            var UpdateBillToEmail = function () {

                let billToEmail = $("input[Name=billtoemail]");

                if (billToEmail.length > 0) {
                    billToEmail.val(YouLi.Trip.Payments.BillToEmail);
                    billToEmail.prop("readOnly", billToEmail.val().length > 0)
                }
            }

            var UpdateChargeDetails = function (label) {

                /// Add surcharge and any other charges to the amount before setting
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                let selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();
                let surchargeAmount = 0;
                let totalAmountDue = 0;

                if (selectedPaymentMethod === "thirdpartycard") {
                    surchargeAmount = parseFloat((YouLi.PaymentChargeForm.AmountDue * YouLi.Trip.Payments.ThirdPartyCardSurchargePercent / 100).toFixed(2));
                    $(".payment-surcharge-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption && YouLi.Trip.Payments.ThirdPartyCardSurchargePercent > 0) {
                        $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }
                }
                else if (selectedPaymentMethod === "savedpaymentmethod" || selectedPaymentMethod === "paymentgateway") {
                    const paymentMethod = selectedPaymentMethod === "savedpaymentmethod" ? YouLi.Trip.Payments.SaveCardMethodType : null;

                    surchargeAmount = YouLi.PaymentChargeForm.GetSurchargeAmount(paymentMethod);

                    $(".payment-surcharge-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption
                        && YouLi.PaymentChargeForm.Default.SurchargePercent > 0
                        && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {

                        // show the surcharge for the selected payment method
                        let selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');
                        selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                    }
                }
                else if (YouLi.Trip.Payments.ApplySurchargeToAllMethods) {
                    // this is for payments like bank transfer, phone, custom link, etc. where the planner has set a surcharge to "apply to all payment methods"
                    surchargeAmount = YouLi.PaymentChargeForm.GetSurchargeAmount(selectedPaymentMethod);

                    $(".payment-surcharge-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption
                        && YouLi.PaymentChargeForm.Default.SurchargePercent > 0) {
                        let selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');
                        selectedPaymentMethodElement.closest(".row").find(".payment-surcharge-val").removeClass("hidden");
                    }
                }

                totalAmountDue = YouLi.PaymentChargeForm.AmountDue + surchargeAmount;

                // add Refund Protect (if applicable and selected)
                $(".refund-protect-val").addClass("hidden");
                let refundProtectAmount = 0;
                let refundProtectPercentage = 0;
                if (YouLi.Trip.Payments.RefundProtectPercent > 0
                    && selectedPaymentOption
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val() != undefined
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedin"
                ) {

                    refundProtectAmount = parseFloat((totalAmountDue * YouLi.Trip.Payments.RefundProtectPercent / 100).toFixed(2));
                    refundProtectPercentage = YouLi.Trip.Payments.RefundProtectPercent;
                    $(".refund-protect-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(refundProtectAmount)}`);

                    $(".refund-protect-val").removeClass("hidden");
                }
                else {
                    $(".refund-protect-val").addClass("hidden");
                }

                YouLi.PaymentChargeForm.UpdatePaymentInfo({
                    surchargeAmount: surchargeAmount,
                    refundProtectAmount: refundProtectAmount,
                    refundProtectPercent: refundProtectPercentage
                });

                if ((selectedPaymentMethod === "paymentgateway" || selectedPaymentMethod == "savedpaymentmethod") && YouLi.PaymentChargeForm.Ach.HasSurcharge === true) {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmountNoSurcharge()));
                    $('#GenericPaymentFormDialog')
                        .find('.cost-line-item-amount-payment-total')
                        .html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                } else {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                }

                $("input[Name=RefundProtectAmount]").val(refundProtectAmount);
                $("input[Name=ChargeAmount]").val(YouLi.PaymentChargeForm.GetChargeAmount());
                $("input[Name=SurchargeAmount]").val(surchargeAmount);

                if (label) {
                    $("input[Name=ChargeLabel]").val(label);
                }

                // trigger the change event on the ChargeAmount field for things like updating the payment intent for Stripe
                $("input[Name=ChargeAmount]").trigger("change");
            };

            var RefreshInviteesTab = function (tabHTML, showInviteeTab) {
                if (showInviteeTab) {
                    // Display and refresh invitees tab (if not already displayed)
                    $(".content-tab-invitees").removeClass("hidden");

                    $("#invitees-content").html(tabHTML);

                    YouLi.Trip.SetupInviteeSectionMenu();
                }
            }

            var continuePayment = function () {
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                switch (selectedPaymentMethod) {

                    case "savedpaymentmethod":
                        const totalAmount = YouLi.PaymentChargeForm.GetChargeAmount();
                        $("#SavedPaymentMethodConfirmationDialog .current-payment-amount").text(YouLi.PaymentChargeForm.GetFormattedCurrency(totalAmount));
                        $('#ChargeAmount').val(totalAmount);

                        $("#AutoPayEnrolOption").toggleClass("hidden", YouLi.Trip.Payments.SelectedInstallmentId == YouLi.Trip.Payments.InstallmentIdBalance);

                        $("#EnrolInAutoPay").prop("checked", YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay);
                        YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay = false; // reset for next time

                        $("#SavedPaymentMethodConfirmationDialog").modal("show");

                        break;

                    case "thirdpartycard":

                        if (!$("#PaymentCostChargingDetailsForm").valid())
                            return;

                        $("#SavedThirdPartyCardConfirmationDialog .current-payment-amount").text(
                            YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));

                        $("#SavedThirdPartyCardConfirmationDialog").modal("show");

                        break;

                    case "paymentgateway":
                        doContinueStripePayment();

                        break;
                    case "banktransfer":
                    case "paypallink":
                    case "phone":
                    case "customlink":
                        YouLi.Trip.Payments.CheckForOverpayment()
                            .then(() => processPayment(selectedPaymentMethod));

                        break;
                }

                // this is a step to allow any stripe setup to be allowed to have a payment form
                const isStripeData = $('input[type=radio][name=PaymentMethod]:checked').data('is-stripe');
                const isStripe = isStripeData === true || isStripeData === "true";

                if(YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled && isStripe) {
                    doContinueStripePayment();
                }
            };

            function continuePaymentOrDoCountryCapping() {
                UpdateBillToEmail();
                UpdateChargeDetails(undefined);
                const selectedPaymentMethodSurchargePercent = parseFloat($('input[type=radio][name=PaymentMethod]:checked').data('surcharge-percent')) || 0;

                if (YouLi.Trip.SurchargeCapping.IsSurchargeCappingEnabled && selectedPaymentMethodSurchargePercent > 0) {
                    YouLi.Trip.SurchargeCapping.CallbackForModalConfirm = continuePayment;
                    $('#SurchargeCappingCountryModal').modal('show');
                } else {
                    continuePayment();
                }
            }

            function doContinueStripePayment() {
                //google tag manager
                if ($("#IsBooked").val() == "" || $("#IsBooked").val() == "False") {
                    var gaData = YouLi.Common.GetGAData("begin_checkout");
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push(gaData);
                }

                // log analytics - don't do anything on success/fail
                YouLi.Common.Post({
                    url: `/trip/logpaymentclick?tripId=${$("#TripId").val()}&inviteeId=${$("#InviteeId").val()}`,
                }).then((response) => {
                    if (response.cookieError && response.message) {
                        YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.message, "Identity error");
                    }
                });

                YouLi.Common.UI.ShowLoading();

                if (YouLi.Trip.Payments.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Stripe) {
                    YouLi.CreditCardPaymentForm.StripePay.InitialiseStripe()
                        .then(() => {

                            YouLi.Common.UI.HideLoading();

                            $("#GenericPaymentFormDialog").modal("show");
                        });
                }
                else {
                    YouLi.Common.UI.HideLoading();

                    $("#GenericPaymentFormDialog").modal("show");
                }
            }

            YouLi.Trip.Payments.InitialiseUI = function () {
                YouLi.Trip.Payments.InitialiseResponseChecks();
                YouLi.Common.UI.Init();
            };

            YouLi.Trip.Payments.UpdateTripPackage = function (selectedPackageId, selectedTripPackageRoomId) {

                const defaultPromise = new Promise((resolve, reject) => {
                    resolve('Success!');
                });

                let programTabIsHidden = $("#content-trip-program").hasClass("hidden");
                let itineraryTabIsHidden = $("#content-trip-itinerary").length == 0 || $("#content-trip-itinerary").hasClass("hidden");
                let taskTabIsHidden = $("#content-trip-tasks").length == 0 || $("#content-trip-tasks").hasClass("hidden");
                let selectedMenuSection = $(".content-trip-details-menu .nav li.active").data("section");

                var previewMode = $("#PreviewMode").val();
                if (selectedPackageId) {

                    var tripId = $("#TripId").val();
                    var inviteeId = $("#InviteeId").val();

                    return YouLi.Common.Get({
                        url: '/trip/UpdateInviteeTripPackage/',
                        params: {
                            packageId: selectedPackageId,
                            packageRoomId: selectedTripPackageRoomId,
                            tripId: tripId,
                            inviteeId: inviteeId,
                            preview: previewMode
                        },
                    }).then((response) => {
                        if (response.url) {
                            window.location.href = response.url;
                        }
                        else if (response.success === false) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                        }
                        else {

                            if (response.showCosts) {
                                $(".content-tab-paymentdetails").removeClass("hidden");
                            }

                            var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                            if ($(".content-trip-paymentdetails-costs").length > 0)
                                $(".content-trip-paymentdetails-costs").html(response.paymentDetailsHtml);

                            $(".package-card").html(response.packageCardHtml);
                            $(".content-trip-heading-details-cost").html(response.tripCostSummaryHtml);

                            // Update payment info - but only if the server has passed it back
                            if ($(".content-trip-paymentdetails-payment-info").length > 0 && response.paymentInfoHtml.length > 0)
                                $(".content-trip-paymentdetails-payment-info").html(response.paymentInfoHtml);

                            YouLi.Trip.UpdateProgramContent(programTabIsHidden, response.contentProgramHtml);
                            YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);
                            YouLi.Trip.UpdateTaskContent(taskTabIsHidden, response.contentTaskHtml);
                            YouLi.Trip.UpdateMenuContent(selectedMenuSection, response.menuHtml);

                            YouLi.Trip.Schedule.Response.InitialiseResponseChecks();

                            //google analytics
                            var preveiousSelectedTripPackage = $("#GA_PackageName").val();

                            PushRemoveCartGAData();
                            $("#GoogleAnalyticsData").html(response.googleAnalyticsHtml);
                            PushAddCartGAData();

                            YouLi.Trip.Payments.InitialiseUI();
                            YouLi.Common.UI.Init();

                            // reinitialise
                            $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                            ChangeMethod(initialSelectedPaymentMethod, true);

                            // YOULI-5433 turning off this footer button refresh here, as we don't actually see any need to refresh the footer now.  It's already
                            // refreshed above based on the selected payment method.
                            //if (!$("input[type=radio][name=PaymentMethod]:checked").val()) {
                            //    // Have to force footer update after package selection changes even if any payment method hasn't been selected
                            //    SetFooterToPaymentButton(true);
                            //}
                        }
                    });
                }

                return defaultPromise;

            }

            YouLi.Trip.Payments.CancelAutoPay = function () {

                YouLi.Common.UI.ShowLoading();

                YouLi.Common.Post({
                    url: '/Trip/CancelAutoPayEnrollment',
                    params: { tripId: $("#TripId").val(), inviteeId: $("#InviteeId").val() },
                    errorCallback: () => {
                        YouLi.Common.UI.HideLoading();
                        YouLi.Common.UI.ShowStandardDialog("An error occurred when cancelling AutoPay. Try again or contact your planner.");
                    }
                }).then((response) => {
                    YouLi.Common.UI.HideLoading();

                    if (!response.success) {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred when cancelling AutoPay. Try again or contact your planner.");
                    }
                    else {
                        $(".content-trip-paymentdetails-costs").html(response.contentCostPaymentDetailsHtml);
                        YouLi.Trip.Payments.RefreshPaymentMethod(true);
                    }
                });
            };

            var PushRemoveCartGAData = function () {
                //remove_from_cart event
                var removeFromCartData = YouLi.Common.GetGAData("remove_from_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            var PushAddCartGAData = function () {
                //add_to_cart
                var removeFromCartData = YouLi.Common.GetGAData("add_to_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            InitialisePayments = function () {

                // If credit card is the only payment method, initialise to select that.  Otherwise leave it unselected so the user
                // has to review details before seeing the "notify" button
                if ($("input[name=PaymentMethod]:not(':disabled')").length == 1) {
                    if ($("input[name=PaymentMethod]:not(':disabled')").val() === "paymentgateway") {
                        $("input[name=PaymentMethod]:not(':disabled')").attr("checked", true);
                    }
                }

                // If remaining balance is the only payment option, initialise to select that.
                if ($("input[name=PaymentOption]:not(':disabled')").length == 1) {
                    if ($("input[name=PaymentOption]:not(':disabled')").val() === "balance") {
                        $("input[name=PaymentOption]:not(':disabled')").attr("checked", true);
                    }
                }

                $(document).on("change", "input[type=radio][name=PaymentOption]", function () {
                    var selectedOption = $(this).val();

                    ChangePaymentOption(selectedOption);
                });
                //ChangePaymentOption($("input[type=radio][name=PaymentOption]:checked").val());        // YOULI-8514 remove initial server call

                $(document).on("change", "input[type=radio][name=PaymentMethod]", function () {
                    var selectedMethod = $(this).val();

                    ChangeMethod(selectedMethod, false, true);

                });
                ChangeMethod($("input[type=radio][name=PaymentMethod]:checked").val(), true);

                $(document).on("change", "input[type=radio][name='CurrentInvitee.RefundProtectSelection']", function () {

                    // trigger change method, but it will just be for updating refund protect
                    var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();
                    ChangeMethod(selectedPaymentMethod, true, true); // Nb: no scroll when changing Refund Protect

                });
                ChangeMethod($("input[type=radio][name=PaymentMethod]:checked").val(), true);


                $(document).on("click", ".apply-coupon-code", function () {

                    if ($("#PreviewMode").val().toLowerCase() == "true")
                        return;

                    $(".content-trip-coupon-code-error").addClass("hidden");

                    let selectedCouponCode = $("#SelectedCouponCode").val();

                    const data = {
                        couponCode: selectedCouponCode,
                        tripId: $("#TripId").val(),
                        inviteeId: $("#InviteeId").val(),
                        installmentId: YouLi.Trip.Payments.SelectedInstallmentId
                    };

                    YouLi.Common.Post({
                        url: '/trip/applycouponcode/',
                        params: data,
                    }).then((response) => {
                        if (response.url) {
                            window.location.href = response.url;
                        }
                        else if (response.success === false) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                        }
                        else if (response.errorMessage) {
                            $(".content-trip-coupon-code-error").removeClass("hidden")
                            $("#CouponCodeErrorMessage").text(response.errorMessage);
                        }
                        else if (response.cookieError && response.message) {
                            YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.message, "Identity error");
                        }
                        else {

                            //google tag manager
                            if ($("#IsBooked").val() == "" || $("#IsBooked").val() == "False") {
                                var gaData = YouLi.Common.GetGAData("select_promotion");
                                dataLayer.push({ ecommerce: null });
                                dataLayer.push(gaData);
                            }

                            $("#SelectedCouponCode").val("");
                            $("#BreakdownTable").html(response.newPaymentsBreakdownTable);
                            $(".content-trip-heading-details-cost").html(response.newCostSummaryHtml);
                            if ($(".cost-installments-selection:not(.individual)").length > 0) {
                                $(".cost-installments-selection:not(.individual)").html(response.newInstallmentsTableHtml);
                            }
                            YouLi.Trip.Payments.InitialiseUI();
                            $("input[Name=ChargeCouponCode]").val(selectedCouponCode);

                            // if balance is being paid, update the current amount due. For all other installments, we do NOT reduce the amount based on the coupon code.
                            if (response.isBalance) {
                                YouLi.PaymentChargeForm.AmountDue = response.balanceAmount;
                            }

                            UpdateChargeDetails(undefined);

                            $(".amount-due-balance").html(YouLi.PaymentChargeForm.GetFormattedCurrency(response.balanceAmount));
                        }

                    });
                });
            };

            $(function () {

                YouLi.Trip.Payments.InitialiseUI();

                $(document).on("click", ".pay-now-button", function () {

                    YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay = $(this).hasClass("enrol-in-autopay");    // store for later use

                    if ($("#RecentPaymentMadeDialog").length == 1) {
                        $("#RecentPaymentMadeDialog .current-payment-amount").text(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                        $("#RecentPaymentMadeDialog").modal("show");
                        return;
                    }

                    YouLi.Trip.Payments.RefundProtectOptedOutConfirmed = false;

                    if ($("#RefundProtectConfirmationDialog").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedout") {
                        $("#RefundProtectConfirmationDialog").modal("show");
                        return;
                    }

                    continuePaymentOrDoCountryCapping();
                });

                $(document).on("click", "#RecentPaymentConfirmationFormOk", function () {

                    $("#RecentPaymentMadeDialog").modal("hide");

                    continuePaymentOrDoCountryCapping();
                });

                $(document).on("click", "#RefundProtectConfirmationFormOk", function () {

                    if (!$("#RefundProtectConfirmationForm").valid())
                        return;

                    $("#RefundProtectConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.RefundProtectOptedOutConfirmed = true;

                    continuePayment();
                });

                $(document).off("click", "#SavedPaymentMethodConfirmationOk");
                $(document).on("click", "#SavedPaymentMethodConfirmationOk", function () {

                    $("#SavedPaymentMethodConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.processPaymentWithSavedPaymentMethod(false);
                });

                $(document).off("click", "#SavedThirdPartyCardConfirmationOk");
                $(document).on("click", "#SavedThirdPartyCardConfirmationOk", function () {

                    $("#SavedThirdPartyCardConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.processPaymentWithSavedPaymentMethod(true);
                });

                $(document).on('click', '.save-card-login a', function (e) {
                    e.preventDefault();
                    const persona = 'traveler';
                    const redirectUrl = $(this).attr('href');

                    window.location.href = `${redirectUrl}?defaultPersona=${persona}`;
                })

                if (YouLi.Trip.Payments.InviteeHasOwing) {
                    // showing payment details and form
                    InitialisePayments();
                }

                $(document).on("change", "#SelectedPackageId", function () {
                    YouLi.Trip.Payments.UpdateTripPackage($(this).val());
                });

                $(document).on('input', '#CurrentInvitee_ChipAwayPaymentAmount', function () {
                    $(this).val($(this).val().replace(/[^\d.]/g, ''));
                });

                $(document).on('blur', '#CurrentInvitee_ChipAwayPaymentAmount', function () {
                    $("#ChipAwayErrorMessage").addClass("hidden");
                    GetSelectedPaymentOptionAmount();   // update the amount to be charged
                    TogglePaymentButtonVisiblity();
                });

                $(document).on("click", "#ChangeAutoPayPaymentMethod", function () {
                    $("#ChangeAutoPayConfirmationDialog").modal("show");
                });
                $(document).on("click", "#CancelAutoPay", function () {
                    $("#CancelAutoPayConfirmationDialog").modal("show");
                });

                $(document).on("click", ".cancel-autopay-button", function () {

                    $("#ChangeAutoPayConfirmationDialog").modal("hide");
                    $("#CancelAutoPayConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.CancelAutoPay();
                });

                // If credit card payemnt form is loaded (it won't be initially for $0 packages)
                if (YouLi.CreditCardPaymentForm) {
                    var selectedOption = $('input[type=radio][name=PaymentOption]:checked').val();
                    YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");
                }


                // Trim fields that we do not want to allow spaces in
                $(".trim-before-validation").on("blur", function () {
                    $(this).val($(this).val().trim());
                });
            });

        }(YouLi.Trip.Payments ? YouLi.Trip.Payments : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));